export const IMPC_EDIT_REQUEST = 'IMPC_EDIT_REQUEST';
export const IMPC_EDIT_SUCCESS = 'IMPC_EDIT_SUCCESS';
export const IMPC_EDIT_FAILURE = 'IMPC_EDIT_FAILURE';
